import { render, staticRenderFns } from "./SelectRedirect.vue?vue&type=template&id=6c7d0247&"
import script from "./SelectRedirect.vue?vue&type=script&lang=js&"
export * from "./SelectRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports